import { Routes, Route, Navigate } from "react-router-dom";
import TenantProtectedRoutes from "./TenantProtectedRoutes";
import Layout from "../components/admin/Organisation/Layout/Layout";
import Dashboard from "../components/admin/Organisation/Dashboard/Dashboard";
import Licence from "../components/admin/Organisation/Licence/Licence";
import AddSchool from "../components/admin/Organisation/School/AddSchool";
import EditSchool from "../components/admin/Organisation/School/EditSchool";
import School from "../components/admin/Organisation/School/School";
import {
  ManualPaymentForm,
  ManualPaymentInfo,
  PurchaseLicenses,
} from "../components/admin/SchoolAdmin/Account/License";

import SchoolDetail from "../components/admin/Organisation/School/SchoolDetail";
import SettingsLayout from "../components/admin/SchoolAdmin/Account/SettingsLayout";
import {
  AdminProfilePage,
  LicensesPage,
  PaymentsPage,
} from "../components/admin/SchoolAdmin/Account/pages";
import Invoice from "../components/admin/SchoolAdmin/Account/Payment/Invoice";
import ViewPayment from "../components/admin/SchoolAdmin/Account/Payment/ViewPayment";
import LicensePayment from "../components/admin/payment/LicensePayment";
import Notification from "../components/admin/Organisation/Notification/Notification";
import CreateNotification from "../components/admin/Organisation/Notification/CreateNotification";
import NotificationDetail from "../components/admin/Organisation/Notification/NotificationDetail";

const OrganisationRoutes = () => {
  return (
    <Routes>
      <Route
        path=""
        element={
          <TenantProtectedRoutes tenantType="organization-admin">
            <Layout />
          </TenantProtectedRoutes>
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="school/add-school" element={<AddSchool />} />
        <Route path="school/edit/:id" element={<EditSchool />} />
        <Route path="school" element={<School />} />
        <Route path="school/:id" element={<SchoolDetail />} />
        <Route path="invoice" element={<Invoice />} />
        <Route path="notification" element={<Notification />} />
        <Route path="notification/create" element={<CreateNotification />} />
        <Route path="notification/:batchId" element={<NotificationDetail />} />
        {/* <Route path="license" element={<PurchaseLicenses />} /> */}
        <Route path="license/assign" element={<Licence />} />
        {/* <Route path="settings" element={<OrgaizationSettings />} /> */}

        {/* Settings routes (nested route structure with SettingsLayout as parent) */}
        <Route path="settings" element={<SettingsLayout type="organization" />}>
          <Route index element={<Navigate to="profile" replace />} />
          <Route path="profile" element={<AdminProfilePage />} />
          <Route
            path="payments"
            element={<PaymentsPage type="organization" />}
          />
          <Route path="invoices" element={<Invoice type="organization" />} />
          <Route
            path="licenses"
            element={<LicensesPage type="organization" />}
          />
        </Route>
        <Route path="view/payment/:paymentId" element={<ViewPayment />} />

        <Route
          path="settings/purchase-licenses"
          element={<PurchaseLicenses type="organization" />}
        />
        <Route
          path="settings/purchase-licenses/manual-payment-info"
          element={<ManualPaymentInfo type="organization" />}
        />
        <Route
          path="/purchase-licenses/manual-payment-form/:paymentId"
          element={<ManualPaymentForm type="organization" />}
        />
        <Route
          path="settings/purchase-licenses/manual-payment-form"
          element={<ManualPaymentForm type="organization" />}
        />
        <Route path="/:invoiceId/payment" element={<LicensePayment />} />

        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Route>
    </Routes>
  );
};

export default OrganisationRoutes;
